import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContentStateProperty, DistanceToFieldType } from '../../../../../../@types/types'
import { ConnectionsScreenValidationResult } from '../../../../../../@types/validation-types'
import {
  InsertionFlowPagesTypeWithDistanceToFields,
  InsertionFlowScreensProps,
} from '../../../../../../@types/props-types'

// infinite loop bug in prettier
// prettier-ignore
const withDistanceToFields =
  (Component: React.FC<InsertionFlowPagesTypeWithDistanceToFields >) =>
    ({ ...props }: InsertionFlowScreensProps<ConnectionsScreenValidationResult>) => {
      const { t } = useTranslation()
      const distanceToFields: DistanceToFieldType[] = [
        {
          id: 'distance-to-pt',
          fieldName: 'distanceToPT' as ContentStateProperty,
          label: <>{t('wizard.screen.connections.distanceToPT', 'Walking distance to public transport')}</>,
          maxLength:2
        }, {
          id: 'distance-to-mrs',
          fieldName: 'distanceToMRS' as ContentStateProperty,
          label: <>{t('wizard.screen.connections.distanceToMRS', 'Main Railway Station')}</>,
          requiresMargin: true,
          maxLength:2
        }, {
          id: 'distance-to-fm',
          fieldName: 'distanceToFM' as ContentStateProperty,
          label: <>{t('wizard.screen.connections.distanceToFM', 'Highway')}</>,
          requiresMargin: true,
          maxLength:3
        }, {
          id: 'distance-to-airport',
          fieldName: 'distanceToAirport' as ContentStateProperty,
          label: <>{t('wizard.screen.connections.distanceToAirport', 'Airport')}</>,
          requiresMargin: true,
          maxLength:3
        }
      ]
      return <Component {...props} distanceToFields={distanceToFields} />
    }

export default withDistanceToFields
